import { render } from "./ActionDisplayFreeModel.vue?vue&type=template&id=d2f69f3a"
import script from "./ActionDisplayFreeModel.vue?vue&type=script&lang=ts"
export * from "./ActionDisplayFreeModel.vue?vue&type=script&lang=ts"
script.render = render

export default script